/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { ContentRecommendation } from '@/components/content/ContentRecommendation';
import { Skeleton } from '@mui/material';

const EMS_NAME = 'DPV2PDPPromotionShort';

const EmptyElement = () => null;

export const ProductDetailsPromotionShort = () => (
	<ContentRecommendation
		id={EMS_NAME}
		properties={{ emsName: EMS_NAME }}
		withoutFrame
		loadingElement={<Skeleton sx={{ height: '27px', width: '100%' }} />}
		emptyElement={<EmptyElement />}
	/>
);
